<div *ngIf="headline" class="text">
  <span>{{ headline }}</span>
</div>
<hr class="separator" noshade />

<ng-content></ng-content>
